import React from "react";
import Navbar from "../Navbar";

export default function MigrationHero() {
  return (
    <section className="px-6 border-b border-primary-soft bg-primary">
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex mt-10 items-center justify-center px-6 py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl mt-10 sm:text-4xl md:text-5xl lg:text-6xl text-white font-bold mb-4 sm:mb-6 leading-tight animate-fade-in-up">
              Vector Database Migration: Complete Guide for AI Teams
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/70 leading-relaxed mb-6 sm:mb-8 animate-fade-in-up">
              Master vector database migration strategies to optimise your AI infrastructure.
              Learn when to migrate, best practices for seamless transitions, and how to avoid
              common pitfalls in moving vector embeddings between platforms.
            </p>
            <div className="flex flex-wrap justify-center gap-3 text-sm animate-fade-in-up">
              <span className="px-4 py-2 border border-white/40 text-white/80 rounded-full">RAG Pipelines</span>
              <span className="px-4 py-2 border border-white/40 text-white/80 rounded-full">Vector Embeddings</span>
              <span className="px-4 py-2 border border-white/40 text-white/80 rounded-full">AI Infrastructure</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}